export default {
  getStationBaseList: 'getStationBaseList',
  postArealRainfallInfo: 'postArealRainfallInfo',
  getArealRainfallList: 'getArealRainfallList',
  postCollocationStationInfo: 'postCollocationStationInfo',
  getConfiguredArealRainfallStation: 'getConfiguredArealRainfallStation',
  getlog: 'getlog'
}
